"use client";
import React, { useRef } from "react";
import ActionButtons from "./units/ActionButtons";
import Barcode from "react-barcode";
import CodeValueBox from "./units/CodeValueBox";
import { toPng } from "html-to-image";
import { saveAs } from "file-saver";

interface QrCodeProps {
  qrCodeValue: string;
  onClickClose: () => void;
}

const QrCode: React.FC<QrCodeProps> = ({ qrCodeValue, onClickClose }) => {
  const divRef = useRef(null);

  const handleDownload = () => {
    if (divRef.current === null) {
      return;
    }

    toPng(divRef.current)
      .then((dataUrl) => {
        saveAs(dataUrl, "downloaded-div.png");
      })
      .catch((err) => {});
  };

  return (
    <section className="flex flex-col rounded-xl shadow-xl  w-full text-center">
      <main className="flex flex-col items-center px-6 pb-5 mt-2.5 w-full whitespace-nowrap max-md:px-5 max-md:max-w-full">
        <div
          ref={divRef}
          className="flex flex-col justify-center items-center rounded-xl shadow-xl bg-[#323538] text-center w-full p-2"
        >
          <div className="overflow-hidden rounded-xl h-[142px] mb-4">
            <Barcode value={qrCodeValue} width={3} />;
          </div>
          <CodeValueBox qrCodeValue={qrCodeValue} />
        </div>

        <ActionButtons
          handleDownload={handleDownload}
          onClickClose={onClickClose}
        />
      </main>
    </section>
  );
};

export default QrCode;
